// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { keyedReviver } = require('client-v2/common/state/revivers')

class SearchQueryRecord extends Immutable.Record({
  decoded: String(),
  encoded: String()
}) {
  // No methods
}

SearchQueryRecord.reviver = keyedReviver(SearchQueryRecord, {
  // No nested data structures
})

module.exports = SearchQueryRecord
